<nz-form-label [attr.nzFor]="formFieldInfo.fieldCode" [hidden]="hideTitle" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control [formGroup]="formGroup">
    <input style="width:100%" nz-input type="text" nzSize="large" [id]="formFieldInfo.fieldCode"
        (change)="onChangeNumber($event)" (keyup)="onChangeNumber($event)" [value]="value" [attr.maxlength]="maxlength"
        [formControlName]="formFieldInfo.fieldCode" [(ngModel)]="value" (ngModelChange)="modelChange()" />
</nz-form-control>